import { Accordion } from "@app/shared/Accordion"
import { FC, useContext } from "react"
import { ProviderHubContext } from "@app/projects/network-assessment/provider-hub/contexts/ProviderHubContext";
import formatPhoneNumber from "@app/shared/formatPhoneNumber";
import { QESButton } from "@app/shared/qes-standards/Button";
import { ProviderProfileReferrerEnum } from "@app/projects/network-assessment/provider-hub/provider-profile/interfaces/providerProfileReferrerEnum";

export const OrganizationProfileContractEntity: FC = () => {
  const providerHubContext = useContext(ProviderHubContext);
  const { selectedContractEntity } = providerHubContext;

  const handleContractEntityClick = () => {
    providerHubContext.navigateToContractEntityProfile(selectedContractEntity, ProviderProfileReferrerEnum.OrganizationProfile);
  }

  return (
    <Accordion title="Contract Entity" testId="provider-profile__providers-accordion" defaultOpen={true} className="provider-profile__overview">
      <dl>
        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-label">Name</dt>
          <dd className="provider-profile__overview-value">
            <QESButton
                      qesType="link"
                      qesTestId={`provider-hub-contractentity-view__provider--${selectedContractEntity.name}`}
                      onClick={() => { handleContractEntityClick() }}
                      className="demibold"
                    >
                      {selectedContractEntity.name ?? "---"}
                    </QESButton>
          </dd>
        </div>

        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-label">Type</dt>
          <dd className="provider-profile__overview-value">
            {selectedContractEntity.entityType}
          </dd>
        </div>

        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-label">Phone Number</dt>
          <dd className="provider-profile__overview-value">
            {formatPhoneNumber(selectedContractEntity.phoneNumber)}
          </dd>
        </div>
      </dl>
    </Accordion>
  )
};